import { useEffect, useState } from 'react';
import { formatErrorImage } from '../utils/modifyImageLink';

const useImageFallback = (src, { placeholder } = {}) => {
  const [fallbackSrc, setFallbackSrc] = useState(null);

  useEffect(() => {
    setFallbackSrc(null);
  }, [src]);

  const onError = () => {
    setFallbackSrc((prev) => {
      if (prev) return placeholder;

      const retrySrc = formatErrorImage(src, placeholder);
      return retrySrc === src ? placeholder : retrySrc;
    });
  };

  return { src: fallbackSrc || src, onError };
};

export default useImageFallback;
